// src/components/assinatura/JanelaAtivar.js — o mesmo cartão de
// AtivarAssinatura numa janela, aberto pelo selo "Período de teste" da
// TopBar e pelo botão da tela Assinatura (out/26).
import { useId } from 'react';
import { Dialog } from '@mui/material';
import AtivarAssinatura from './AtivarAssinatura';

export default function JanelaAtivar({ aberta, onFechar, onAtivada }) {
  const tituloId = useId();
  return (
    <Dialog
      open={aberta}
      onClose={onFechar}
      aria-labelledby={tituloId}
      PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', m: 2, width: '100%', maxWidth: 500, overflow: 'visible' } }}
      slotProps={{ backdrop: { sx: { bgcolor: 'rgba(7,11,20,0.45)', backdropFilter: 'blur(5px)' } } }}
    >
      {aberta && (
        <AtivarAssinatura
          tituloId={tituloId}
          onFechar={onFechar}
          onAtivada={() => { onAtivada?.(); onFechar(); }}
        />
      )}
    </Dialog>
  );
}
